<template>
  <div class="register">
    <login-header v-bind="headerInfo"></login-header>
    <div class="content">
      <div class="zc-tit">注册会员</div>
      <div class="zc-box">
        <form>
          <ul class="zc-list">
            <li class="clearfix login-input"><input type="text" class="input" placeholder="手机号码" v-model="userInfo.phone" id="mobile" name="mobile"></li>
            <li class="clearfix yzm login-input">
              <input type="text" class="input" placeholder="验证码" maxlength="4" v-model="userInfo.codeValue" ref="verificationCode">
              <button type="button" class="btn-yzm btn-msg" @click="sendCode()">获取验证码</button>
            </li>
            <li class="clearfix">
              <div class="tips">收不到验证码？点击获取<a href="javascript:;" id="yzm-tips"  @click="sendCodeVms">语音验证码</a></div>
              <input type="password" class="input" placeholder="设置密码 " v-model="userInfo.pwd">
            </li>
          </ul>
          <div class="protocol clearfix">
            <label><input type="checkbox" id="checkbox1" v-model="userInfo.checked">我已经同意<router-link to="/agreement.html">《注册协议》</router-link></label>
          </div>
        </form>
        <button class="yellow-btn" @click="registerFn">注 册</button>
        <div class="zc-bot clearfix" >
          <div class="tool" v-show="socialization==1">
            <span>其他方式登录</span>
            <a :href="'//inapi.'+hostUrl+'/web/seller/account/qq-login'">
              <span class="icon icon-qq"></span>
            </a>
            <a :href="'//inapi.'+hostUrl+'/web/seller/account/wechat-login'">
              <span class="icon icon-weixin"></span>
            </a>
          </div>
          <div class="zc-link">
            <span><router-link to="/login.html">已有账号，立即登录</router-link></span>
          </div>
        </div>
      </div>
    </div>

    <div ref="popup_captcha2" id="popup-captcha"></div>
    <!--弹窗-->
    <div class="register-alert-box" :style="{display:disVal}" >
      <div class="img"><img src="../../assets/img/warning.jpg"/></div>
      <div class="txt">
        <p>验证码将电话通知到您，来电号码</p>
        <p><em>055182190909</em>，请注意接听</p>
      </div>
      <div class="close" @click="closeDialog">知道了</div>
    </div>

    <!-- 透明遮罩 -->
    <div id="mask" :style="{display:disVal}"  @click="closeDialog"></div>
    <login-footer :description="desc"></login-footer>

  </div>
</template>

<script>
// 注册页面

import loginHeader from '../header'
import loginFooter from '../footer'
import qs from 'qs'
// import {handlerPopup} from '../../../static/js/gt.js';

var sec = 60 // 计时器时间
var clockName = 'smsClock' // 计时器名称
var _method = 'sms'

export default {
  name: 'register',
  components: {
    loginHeader,
    loginFooter
  },
  data() {
    return {
      headerInfo: {
        type: '用户注册',
        userDisplayFlag: false,
        userName: false,
        logo: ''
      },
      desc: '',
      userInfo: {
        phone: '',
        pwd: '',
        checked: true
      },
      disVal: '',
      socialization: 0,
      captchaObj: {},
      hostUrl: '' // 当前域名
    }
  },
  created() {
    // 获取当前域名
    const hostName = window.location.hostname
    if (hostName !== 'www.zvcms.com') {
      const n = hostName.indexOf('.')
      if (n) {
        const host = hostName.substring(n + 1, hostName.length)
        if (host.length > 0) {
          this.hostUrl = host
        }
      }
    } else {
      this.hostUrl = 'zmcms.cn'
    }

    document.title = localStorage.getItem('title')
    this.loginInfo = qs.parse(localStorage.getItem('xdata'))
    this.headerInfo.logo = this.loginInfo.logo
    this.desc = this.loginInfo.desc
    this.socialization = this.loginInfo.is_master
  },
  mounted() {
    this.initGee()
  },

  methods: {
    initGee() {
      var that = this
      QM.apinew({
        url: '/seller/account/start-gt',
        method: 'get',
        success: function(data) {
          initGeetest(
            {
              gt: data.data.gt,
              challenge: data.data.challenge,
              product: 'popup', // 产品形式，包括：float，embed，popup。注意只对PC版验证码有效
              offline: !data.data.success // 表示用户后台检测极验服务器是否宕机，一般不需要关注
            },
            that.handlerPopup
          )
        }
      })
    },
    closeDialog() {
      this.disVal = 'none'
    },
    //  拖动验证码
    clocker() {
      var html = ''
      var btn = $('.btn-msg')
      if (sec > 0) {
        sec--
        html = sec + '秒后重发'
        btn.addClass('on')
      } else {
        sec = 60
        html = '发送短信'
        btn.removeClass('on')
        clearInterval(clockName)
      }
      btn.html(html)
    },

    handlerPopup(captchaObj) {
      this.captchaObj = captchaObj
      var that = this
      // 成功的回调
      captchaObj.onSuccess(function() {
        var validate = captchaObj.getValidate()
        QM.apinew({
          url: '/seller/account/validate-gt',
          method: 'post',
          data: {
            mobile: that.userInfo.phone,
            method: _method,
            geetest_challenge: validate.geetest_challenge,
            geetest_validate: validate.geetest_validate,
            geetest_seccode: validate.geetest_seccode
          },
          success: function(data) {
            data.message &&
              that.$message({
                message: data.message,
                type: 'success'
              })
            if (data && data.status === true) {
              // $('#mobile').attr('readonly', true);
              // 启用倒计时
              clockName = setInterval(that.clocker, 1000)
              // 弹出层
              _method === 'vms' && $('#mask,.register-alert-box').show()
            } else {
              that.$message(data.message)
            }
          },
          error: function(data) {
            that.$message(data.message)
          }
        })
      })
      // 将验证码加到id为captcha的元素里
      $('#popup-captcha')[0] && captchaObj.appendTo('#popup-captcha')
    },

    // 获取验证码
    sendCodeVms() {
      var that = this

      if (sec !== 60) {
        this.$message('验证码获取频繁')
        return false
      }

      var mobile_reg = /^1[3-9][0-9]\d{8}$/
      var mobile = that.userInfo.phone

      if (!mobile_reg.test(mobile)) {
        this.$message('请输入正确的手机号')
        return false
      } else {
        _method = 'vms'
      }

      this.captchaObj.show()
    },

    // 短信发送
    sendCode() {
      var that = this
      if (sec !== 60) {
        this.$message('验证码获取频繁')
        return false
      }
      var mobile_reg = /^1[3-9][0-9]\d{8}$/
      var mobile = that.userInfo.phone
      if (!mobile_reg.test(mobile)) {
        this.$message('请输入正确的手机号')
        return false
      } else {
        _method = 'sms'
      }
      this.captchaObj.show()
    },

    registerFn() {
      var that = this
      var mobile_reg = /^1[3-9][0-9]\d{8}$/
      if (!mobile_reg.test(that.userInfo.phone)) {
        that.$message.error('请填写正确的手机号码！')
        return
      }
      if (!that.userInfo.codeValue) {
        that.$message.error('请填写正确的验证码！')
        return
      }
      if (!that.userInfo.pwd) {
        that.$message.error('请填写密码！')
        return
      }
      let fromTag = this.$route.query.from || ''
      let sem = this.$route.query.source || ''
      QM.apinew({
        url: '/seller/account/register',
        method: 'post',
        data: {
          mobile: that.userInfo.phone,
          password: that.userInfo.pwd,
          codeValue: that.userInfo.codeValue,
          from_tag: fromTag,
          sem
        },
        success: function(xdata) {
          that.$message({
            message: xdata.message,
            type: 'success'
          })
          that.$router.push({ path: '/login.html' })
        },
        error: function(xdata) {
          that.$message.error(xdata.message)
        }
      })
    }
  }
}
$(function() {
  // 隐藏
  $('.close,#mask').click(function() {
    $('#mask,.register-alert-box').hide()
  })
})
</script>

<style scoped>
.yellow-btn:hover {
  background: #f7dd68;
}
.login-input{
  height: 62px;
  overflow: hidden;
}
</style>